import { useState, useCallback } from 'react';

/**
 * Expand/collapse 토글 + setter.
 * MedicationGuideCard, accordion, expandable detail 등에 공통.
 */
export const useExpandable = (initial: boolean = false) => {
  const [expanded, setExpanded] = useState(initial);
  const toggle = useCallback(() => setExpanded(v => !v), []);
  const expand = useCallback(() => setExpanded(true), []);
  const collapse = useCallback(() => setExpanded(false), []);
  return { expanded, toggle, expand, collapse, setExpanded };
};
